import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AppText from "../../components/Core/AppText/AppText";
import Flex from "../../components/Layout/Flex";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import FirstLevel from "../../components/Shared/Recruitment/RecruitmentHistoryTreeView/FirstLevel";
import Consultant from "../../models/Consultant";
import { History } from "../../models/RecruitmentHistory";
import { useRecruitmentHistory } from "../../networking/candidate.hooks";
import { historyGrouping } from "../../utils/recruitment.utils";

const RecruitmentHistoryTab: React.FC<{ candidate: Consultant }> = ({ candidate }) => {
	const { t } = useTranslation();

	const { history, isLoading } = useRecruitmentHistory({ userId: candidate.id });

	const [historyData, setHistoryData] = useState<History[]>([]);
	const [historyStatusIds, seHistoryStatusIds] = useState<string[]>([]);

	useEffect(() => {
		if (history) {
			const { groupedHistory, statusItemIds } = historyGrouping(history);

			setHistoryData(groupedHistory);
			seHistoryStatusIds(statusItemIds);
		}
	}, [history]);

	return (
		<div key={candidate?.id}>
			<Flex direction="column" alignItems="center">
				<Flex direction="column" alignItems="flex-start" width="fit-content" margin="0 0 40px 0">
					<AppText size="m" weight="bold" color="grayTextLight" margin="25px 0 10px 0">
						{t("HISTORY")}
					</AppText>
					{isLoading ? (
						<LoadingIndicator />
					) : (
						<FirstLevel
							statusItems={historyData}
							id={candidate?.id as string}
							preExpandedIds={historyStatusIds}
						/>
					)}
				</Flex>
			</Flex>
		</div>
	);
};

export default RecruitmentHistoryTab;
